var DrawableNote = require('../base');

require('raphaelImportSVG');



module.exports = DrawableNote.extend({

    setOriginalShapeAttrsOnParse: function( response ) {
        this.originalShapeAttrs = response.text;
    },

    resetShapeAttrsOnCancelChanges: function() {
        this.set( 'text', this.originalShapeAttrs );
    },

    hasShapes: function() {
        return this.get('text') && this.get('text').length > 0;
    },

    // put this on parse of the note models ?
    shapeModelsToRender: function( page ) {

        var shapes,
            r_shapeSet,
            svg = this.get('text');

        // DVBC - 1184: fix to import back in arrows
        // sets the svg defs (if SVG ... could probably not do if VML but I dont think we care about that anymore),
        // which would otherwise be undefined on if called on Raphael.fn ... (Raphael.fn is a paper)
        // perhaps just pass in a canvas obj here, but then would need to change WF / timing (now the shape models are created prior to canvas view creation)
        // will fix issue rendering arrow shapes on import -- addArrow relies on this being defined,
        // though the svg export would still not output the arrow shapes (if rendered by the CRE)
        // put the custom attributes on here (see notes atop canvas where put on Raphael.fn ...
        // would this break anything outside the viewer's div? -- R._engine.create ...
        //  R._g.doc.body.appendChild(c); -- appends to body with position absolute at 0,0 so its out of the flow of the doc
        // if anything probably a flicker ... maybe position it offscreen ... this is is in a model ...
        // if becomes a problem can change order and use existing paper (draw it first), passIn FV wr and have it append to that div, change css to offscreen
        // keep outlining WF to see whats best

        var dummyPaper = Raphael(0, 0, 0, 0);
        dummyPaper.customAttributes = Raphael.fn.customAttributes; //need to apply the customAttributes to apply shape-type in parseElement

        /* err handling: ensure the svg is not blank or error will result) */
        if ( svg === '' || !svg )
            return;


        /* raphael will get rid of the data type attribute, will need to put back */
        r_shapeSet = dummyPaper.importSVG( $(svg)[0], {

            // each model could have a parseElement -- though its probably wanted at the subtype level
            // it now recognizes data-* attributes but this was done before ( and the one here is not a data-attribute )
            parseElement: function(raphaelEl, domEl) {
                // domEl will have the shapeType attr as persisted in it's html;
                // raphaelEl will have been removed at this point, so but it back for future reference as a custom-attribute
                var shapeType = domEl.getAttribute('shape-type');
                shapeType && raphaelEl.attr('shape-type',shapeType);
                return raphaelEl;
            }

        });

        shapes = _.map( r_shapeSet, function( r_shape, i ) {

            return new this.ShapeModel( r_shape.attrs, {
                parentNote: this,
                pageModel: page,
                shapeIndexOfNote: i
            });

        }, this);

        /*
            Note: once removed from the canvas, shapes Raphael properties will be null --
            however, the properties will be stored on the originalSVG attributes of the model
         */

        r_shapeSet.remove();
        dummyPaper.remove();

        return shapes;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/base.js
 ** module id = 292
 ** module chunks = 0
 **/